<template>
    <div>
        <input type="text" v-model="displayValue" @blur="isInputActive = false" @focus="isInputActive = true"
               class="form-control form-control-sm" :class="cssStyles"/>
    </div>
</template>
<script>
    export default {
        name: "MyCurrencyInput",
        props: {
            value: {
                require: true,
            },
            styles: {
                type: String,
                default: ""
            }
        },
        data: function () {
            return {
                isInputActive: false
            }
        },
        computed: {
            cssStyles() {
                return this.styles
            },
            displayValue: {
                get: function () {
                    if (this.isInputActive) {
                        // Cursor is inside the input field. unformat display value for user
                        return this.value.toString();
                        // {{$options.filters.currency(totalexcisesum, {symbol: '', fractionCount:2})}}
                    } else {
                        // User is not modifying now. Format display value for user interface
                        if (parseFloat(this.value)) {
                            //  return this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ")
                            return this.value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ")

                        } else {
                            return 0;
                        }
                    }
                },
                set: function (modifiedValue) {
                    // Recalculate value after ignoring "$" and "," in user input
                    let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""))
                    // Ensure that it is not NaN
                    if (isNaN(newValue)) {
                        newValue = 0
                    }
                    // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
                    // $emit the event so that parent component gets it
                    this.$emit('input', newValue)
                }
            }
        }
    }
</script>
